'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'police-box';
var width = 384;
var height = 512;
var ligatures = [];
var unicode = 'e021';
var svgPathData = ['M208,200a8.00039,8.00039,0,0,0,8,8h24V176H208Zm80,0V176H256v32h24A8.00039,8.00039,0,0,0,288,200Zm-80-40h32V128H216a8.00039,8.00039,0,0,0-8,8Zm80-24a8.00039,8.00039,0,0,0-8-8H256v32h32ZM104,208h24V176H96v24A8.00039,8.00039,0,0,0,104,208Zm24-80H104a8.00039,8.00039,0,0,0-8,8v24h32Zm48,72V176H144v32h24A8.00039,8.00039,0,0,0,176,200Zm0-64a8.00039,8.00039,0,0,0-8-8H144v32h32ZM208,16a16,16,0,0,0-32,0V32h32ZM368,464H16A15.99954,15.99954,0,0,0,0,480v16a16.00079,16.00079,0,0,0,16,16H368a16.00079,16.00079,0,0,0,16-16V480A15.99954,15.99954,0,0,0,368,464Z', 'M352,464V88a23.99993,23.99993,0,0,0-24-24h-8.02344V48a15.99954,15.99954,0,0,0-16-16H80A15.99954,15.99954,0,0,0,64,48V64H56A23.99993,23.99993,0,0,0,32,88V464ZM96,136a8.00039,8.00039,0,0,1,8-8h24v32H96Zm0,40h32v32H104a8.00039,8.00039,0,0,1-8-8Zm80,136a8.00039,8.00039,0,0,1-8,8H104a8.00039,8.00039,0,0,1-8-8V248a8.00039,8.00039,0,0,1,8-8h64a8.00039,8.00039,0,0,1,8,8Zm0-112a8.00039,8.00039,0,0,1-8,8H144V176h32Zm0-40H144V128h24a8.00039,8.00039,0,0,1,8,8Zm64,48H216a8.00039,8.00039,0,0,1-8-8V176h32Zm0-48H208V136a8.00039,8.00039,0,0,1,8-8h24Zm48,40a8.00039,8.00039,0,0,1-8,8H256V176h32Zm0-40H256V128h24a8.00039,8.00039,0,0,1,8,8Z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.faPoliceBox = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = ligatures;
exports.unicode = unicode;
exports.svgPathData = svgPathData;